import type { TrackedResident } from '@/shared/firebase/types';

export function SosBanner({ residents, onJump }: { residents: TrackedResident[]; onJump: (uid: string) => void }) {
  if (residents.length === 0) return null;
  const first = residents[0];
  const name = first.config?.name || first.uid;
  return (
    <div className="bg-danger text-white rounded-2xl shadow-lift px-4 py-3 flex items-center gap-3">
      <span className="text-2xl animate-pulse" aria-hidden>🆘</span>
      <div className="flex-1 min-w-0">
        <p className="font-bold text-sm leading-tight">SOS activo</p>
        <p className="text-xs opacity-90 truncate">
          {name}
          {residents.length > 1 && <span> y {residents.length - 1} más</span>}
        </p>
      </div>
      <button
        onClick={() => onJump(first.uid)}
        className="bg-white/15 hover:bg-white/25 rounded-xl px-3 py-1.5 text-sm font-semibold backdrop-blur"
      >
        Atender
      </button>
    </div>
  );
}
